//@flow
import React from 'react'
import regionsMap from './images/regionen.svg'
import './styles.scss'


export class Regions extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    return <div className='regions'>
      <h3>Ponctualité par région en 2022</h3>
      <img src={regionsMap} alt='karte' />
      <div className="source">Source: <a href='https://news.sbb.ch/fr/medias/article/115696/bonne-ponctualite-en-2022-les-cff-veulent-maintenir-le-niveau-malgre-les-nombreux-chantiers'>CFF</a></div>
    </div>
  }
}



             